import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import {
  IonContent,
  NavController,
  Platform,
  ViewDidEnter,
  ViewWillEnter,
  ViewWillLeave,
} from '@ionic/angular';
import * as dayjs from 'dayjs';

// import * as utcPlugin from 'dayjs/plugin/utc';
// import * as timezonePlugin from 'dayjs/plugin/timezone';

// dayjs.extend(utcPlugin);
// dayjs.extend(timezonePlugin);

import * as leaflet from 'leaflet';
import { RequestHeaderModel } from 'src/app/models/request-header.model';
import { RequestLineModel } from 'src/app/models/request-line.model';
import { CaptionPipe } from 'src/app/pipes/caption.pipe';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { AsyaSoftService } from 'src/app/services/asya-soft.service';
import { AuthService } from 'src/app/services/auth.service';
import { CartService } from 'src/app/services/cart.service';
import { DataService } from 'src/app/services/data.service';
import { FollowService } from 'src/app/services/follow.service';
import { ModalMakerService } from 'src/app/services/modal-maker.service';
import { RequestService } from 'src/app/services/request.service';
import { ReservationService } from 'src/app/services/reservation.service';
import { SurveyService } from 'src/app/services/survey.service';
import { SwiperOptions } from 'swiper';
import { SwiperComponent } from 'swiper/angular';
@Component({
  selector: 'app-detail-page',
  templateUrl: './detail-page.component.html',
  styleUrls: ['./detail-page.component.scss'],
})
export class DetailPageComponent
  implements ViewWillEnter, ViewWillLeave, ViewDidEnter
{
  @ViewChild('slider') slides: SwiperComponent;

  @ViewChild('content') content: IonContent;

  config: SwiperOptions = {
    slidesPerView: 1,
    pagination: { clickable: true },
    speed: 300, //0.3s transition
    autoplay: { delay: 7000 },
  };

  fullPageSlider = {
    initialSlide: 0,
  };

  icon = {
    icon: leaflet.icon({
      iconSize: [30, 30],
      iconAnchor: [13, 0],
      iconUrl: 'assets/media/marker.svg',
    }),
  };

  categorizedSlider: any = [];
  canReserve = false;
  catalogDisplay = false;
  didInit = false;
  onDidInit = false;
  sliderDisplay = true;
  workingHoursDisplay = false;
  monoSlide = false;
  pdfDisplay = true;
  horizontalSlide = false;
  processing = false;
  fullImage = false;
  spaEntrance = false;
  openPdfCaptionDisplay = false;

  isIos = false;
  pdfLoadError = false;

  days: string[] = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday',
  ];
  pdfLinks: { name: string; url: string; type?: string }[] = [];

  currentPdf: string = null;
  currentPdfType: string = null;

  surveyLink: string;
  surveyCode: string;

  blankPage: boolean = false;
  constructor(
    public modalServ: ModalMakerService,
    public dataServ: DataService,
    public cartServ: CartService,
    private actvrt: ActivatedRoute,
    private changeDetector: ChangeDetectorRef,
    public authServ: AuthService,
    private caption: CaptionPipe,
    private reservationServ: ReservationService,
    private followServ: FollowService,
    private reqServ: RequestService,
    private platform: Platform,
    private analytics: AnalyticsService,
    private surveyServ: SurveyService,
    private router: Router,
    private titleService: Title,
    private asyaSoftServ: AsyaSoftService,
    private navCtrl: NavController
  ) {}

  async ionViewWillEnter() {
    // BU VERİTABANINDAN GELEN ZAMAN BİLGİSİNİN SAATİNİ DEĞİŞTİRMEDEN GÖSTERMEK İÇİN
    // const d1 = dayjs.tz('2023-03-06T08:00:00Z', 'Europe/Istanbul')
    // this.saat = d1.format();

    //BU VERİTABANINDAN GELEN ZAMAN BİLGİSİNİN SAATİNİ TİMEZONE'A GÖRE GÖSTERMEK İÇİN
    // const d2 = dayjs.utc('2023-03-06T08:01:00Z').tz('Europe/Istanbul');
    // this.saat = d2.format();

    const SECTIONID = Number(this.actvrt.snapshot.params.section);
    // path: 'blank/:section/:item',
    // how to get this blank string

    this.blankPage =
      this.actvrt.snapshot.routeConfig.path === 'blank/:section/:item';

    this.isIos = this.platform.is('ios');

    if (
      !this.dataServ.menuSection ||
      SECTIONID !== this.dataServ.menuSection.id
    ) {
      await this.dataServ.getSection(SECTIONID);
    }

    const TABLE = this.actvrt.snapshot.queryParams.table;

    if (TABLE) {
      sessionStorage.setItem('tableNo', TABLE);
    }

    this.reservationServ.tableNo =
      this.actvrt.snapshot.queryParams.table || null;

    if (
      !this.dataServ.menuItem ||
      this.dataServ.menuItem.id !== Number(this.actvrt.snapshot.params.id)
    ) {
      const ITEMID = Number(this.actvrt.snapshot.params.item);

      this.dataServ.getItem(ITEMID);
    }

    this.authServ.control();

    if (this.dataServ.menuItem) {
      const MENUTAGS = this.dataServ.menuItem.tags || [];
      const hasOpenDirectUrl = MENUTAGS.some(
        (tag) => tag.name === 'open_direct_url'
      );
      const websiteUrl = this.dataServ.menuItem.web_site_url;

      if (hasOpenDirectUrl && websiteUrl) {
        // Tüm cihazlarda uyumlu bir şekilde URL'yi aç
        window.location.href = websiteUrl;
        return;
      }
    }

    if (
      this.dataServ.menuItem &&
      this.dataServ.menuItem.booking_system !== 'only timetable' &&
      this.dataServ.menuItem.menu_item_books &&
      this.dataServ.menuItem.menu_item_books.length > 0 &&
      this.dataServ.menuItem.menu_section_id !== 105 &&
      (this.dataServ.rData.open_for_year ||
        (dayjs(new Date()).diff(this.dataServ.rData.open_date) > 0 &&
          dayjs(new Date()).diff(this.dataServ.rData.close_date) < 0))
    ) {
      {
        this.canReserve = true;
      }
    }

    if (this.dataServ.menuItem && this.dataServ.menuItem.menu_item_books) {
      this.dataServ.menuItem.menu_item_books.forEach((book) => {
        if (book.menu_item_book_details) {
          book.menu_item_book_details.map((detail) => {
            // const UTC = dayjs(detail.start_time).utcOffset();
            // detail.start_time = dayjs(detail.start_time).add(-UTC, 'minutes').toISOString();
            // detail.end_time = dayjs(detail.end_time).add(-UTC, 'minutes').toISOString();
          });
        }
      });

      if (
        this.dataServ.menuItem &&
        this.dataServ.menuItem.menu_item_books.length === 1
      ) {
        if (this.dataServ.menuItem.menu_item_books[0].menu_item_book_details) {
          if (
            this.dataServ.menuItem.menu_item_books[0].menu_item_book_details
              .length === 1
          ) {
            this.workingHoursDisplay = true;

            for (const day of this.days) {
              if (!this.dataServ.menuItem.menu_item_books[0][day]) {
                this.workingHoursDisplay = false;
              }
            }
          }
        }
      }
    }

    if (
      this.dataServ.menuItem &&
      this.dataServ.menuItem.survey_header_id &&
      this.authServ.profile
    ) {
      this.surveyCode = await this.surveyServ.getSurveyLinkCode(
        this.dataServ.menuItem.survey_header_id,
        this.authServ.profile.id
      );
      if (this.surveyCode) {
        this.surveyLink = this.surveyCode['survey_link'];
      }
    }

    if (
      this.dataServ.menuSection &&
      this.dataServ.menuSection.survey_header_id &&
      !this.dataServ.menuItem.survey_header_id &&
      this.authServ.profile
    ) {
      this.surveyCode = await this.surveyServ.getSurveyLinkCode(
        this.dataServ.menuSection.survey_header_id,
        this.authServ.profile.id
      );

      if (this.surveyCode.length !== 0) {
        this.surveyLink = this.surveyCode['survey_link'];
      }
    }

    if (this.dataServ.menuItem && this.dataServ.menuItem.pdf_links) {
      this.dataServ.menuItem.pdf_links = this.dataServ.menuItem.pdf_links.sort(
        (a, b) => a.priority - b.priority
      );
      for (const PDF of this.dataServ.menuItem.pdf_links) {
        if (PDF.attachment_url) {
          this.pdfLinks.push({
            name: PDF.description || PDF.name,
            url: PDF.attachment_url,
            type: PDF.type,
          });
        }
      }
    }

    if (
      this.caption.transform(
        this.dataServ.menuItem && this.dataServ.menuItem.url_links
      )
    ) {
      this.pdfLinks.push({
        name: this.dataServ.menuItem.url_title,
        url: this.caption.transform(this.dataServ.menuItem.url_links),
      });
    }

    if (this.pdfLinks && this.pdfLinks.length > 0) {
      this.currentPdf = this.pdfLinks[0].url;
      this.currentPdfType = this.pdfLinks[0].type;
    }

    if (this.dataServ.menuItem && this.dataServ.menuItem.tags) {
      for (const TAG of this.dataServ.menuItem.tags) {
        if (TAG.name === 'slider-none') {
          this.sliderDisplay = false;
        }
        if (TAG.name === 'mono-slide') {
          this.monoSlide = true;
        }
        if (TAG.name === 'horizontal-slide') {
          this.horizontalSlide = true;
        }
        if (TAG.name === 'hide-pdf-preview') {
          this.pdfDisplay = false;
        }
        if (TAG.name.split(':')[0] === 'Asya') {
          this.asyaSoftServ.getAsyasoftToken(); //ASYASOFT TOKEN ALMAK İÇİN
        }
      }
    }

    if (this.dataServ.menuItem?.images) {
      this.dataServ.menuItem.images.forEach((image, index) => {
        if (image.file_name) {
          //how to get this image type

          let TYPE = image.file_name.split('.')[1];
          if (TYPE !== 'mp4') {
            this.categorizedSlider.push({ type: TYPE, url: image.url });
          }
        }
      });
    }

    if (this.dataServ.menuItem && this.dataServ.menuItem.name) {
      this.titleService.setTitle(
        this.caption.transform(this.dataServ.menuItem.name, 'en')
      );
    }

    this.updateSegment();

    this.onDidInit = true;
  }

  refresh() {
    this.processing = true;
    this.pdfLoadError = false; // Reset PDF error state

    setTimeout(() => {
      this.processing = false;
    }, 200);
  }

  updateSegment() {
    if (
      this.caption.transform(this.dataServ.menuItem?.url_links) ===
      this.currentPdf
    ) {
      this.openPdfCaptionDisplay = true;
    } else {
      this.openPdfCaptionDisplay = false;
    }
  }

  ionViewWillLeave() {
    this.cartServ.clearCart();
    this.dataServ.menuItem = null;
    this.dataServ.menuCategory = null;
  }

  async ionViewDidEnter() {
    const SECTIONID = Number(this.actvrt.snapshot.params.section);
    if (
      !this.dataServ.menuSection ||
      SECTIONID !== this.dataServ.menuSection.id
    ) {
      await this.dataServ.getSection(SECTIONID);
    }

    if (
      !this.dataServ.menuItem ||
      this.dataServ.menuItem.id !== Number(this.actvrt.snapshot.params.id)
    ) {
      const ITEMID = Number(this.actvrt.snapshot.params.item);

      this.dataServ.getItem(ITEMID);
    }

    const DURATION = this.sliderDisplay ? 1500 : 50;

    setTimeout(() => {
      if (this.dataServ.menuSection && this.dataServ.menuItem) {
        if (
          this.dataServ.menuSection.catalogue_active &&
          this.dataServ.menuItem.menu_item_catalog_groups &&
          this.dataServ.menuItem.menu_item_catalog_groups.length > 0 &&
          !this.dataServ.menuItem.fix_menu
        ) {
          this.catalogDisplay = true;
        }
      }
    }, DURATION);

    setTimeout(() => {
      this.didInit = true;

      try {
        setTimeout(() => {
          // this.slides.update();
          this.changeDetector.detectChanges();
        }, 500);
      } catch {}

      //! This Area commented because of map component is not used anymore in this component
      // setTimeout(() => {
      //   if (
      //     this.dataServ.menuItem &&
      //     this.dataServ.menuItem.activate_map_location &&
      //     this.dataServ.menuItem.map_location
      //   ) {
      //     const MAP = leaflet
      //       .map('map')
      //       .setView(
      //         [
      //           Number(this.dataServ.menuItem.map_location.split(',')[0]),
      //           Number(this.dataServ.menuItem.map_location.split(',')[1]),
      //         ],
      //         10
      //       );

      //     leaflet
      //       .tileLayer('http://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', {
      //         maxZoom: 20,
      //         subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
      //       })
      //       .addTo(MAP);

      //     leaflet
      //       .marker(
      //         [
      //           Number(this.dataServ.menuItem.map_location.split(',')[0]),
      //           Number(this.dataServ.menuItem.map_location.split(',')[1]),
      //         ],
      //         this.icon
      //       )
      //       .addTo(MAP);
      //   }
      // }, 1000);
    }, 300);

    setTimeout(() => {
      this.refresh();
    }, 300);

    document.querySelectorAll('ion-button').forEach((btn) => {
      btn.addEventListener('click', (event: Event) => {
        const LABEL = (event.target as HTMLElement).getAttribute('label');

        if (LABEL) {
          this.analytics.eventEmitter(
            `${this.caption.transform(
              this.dataServ.menuItem.name,
              this.dataServ.rData.hotel_language || 'tr'
            )}_${LABEL}`,
            'button',
            'click',
            `${this.caption.transform(
              this.dataServ.menuItem.name,
              this.dataServ.rData.hotel_language || 'tr'
            )}_click`,
            this.dataServ.rData.id
          );
        }
      });
    });
  }

  async scrollDetail() {
    const SCROLLY = (await this.content.getScrollElement()).clientHeight;
    this.content.scrollToPoint(0, SCROLLY, 300);
  }

  async openPdf(url: string, type: string) {
    console.log('Opening PDF:', url, 'Type:', type);

    if (!url) {
      console.warn('No PDF URL provided');
      return;
    }

    this.processing = true;

    try {
      switch (type) {
        case 'url':
          // For URL type, transform the URL first then open externally
          const transformedUrl = this.caption.transform(url);
          this.openPdfExternal(transformedUrl);
          break;
        default:
          // For all other types (including when type is undefined), open directly in external browser
          this.openPdfExternal(url);
          break;
      }
    } catch (error) {
      console.error('Error in openPdf:', error);
    } finally {
      // Reset processing state after a short delay
      setTimeout(() => {
        this.processing = false;
      }, 500);
    }
  }

  /**
   * Get PDF viewer URL with fallback options
   */
  getPdfViewerUrl(pdfUrl: string): string {
    if (!pdfUrl) return '';

    // Try Google Docs viewer first, then Mozilla PDF.js as fallback
    const encodedUrl = encodeURIComponent(pdfUrl);

    // Primary: Google Drive viewer
    return `https://drive.google.com/viewerng/viewer?embedded=true&url=${encodedUrl}`;
  }

  /**
   * Handle PDF load success
   */
  onPdfLoad(): void {
    this.processing = false;
    this.pdfLoadError = false;
    console.log('PDF loaded successfully');
  }

  /**
   * Handle PDF load error
   */
  onPdfError(): void {
    this.processing = false;
    this.pdfLoadError = true;
    console.log('PDF failed to load, showing fallback');
  }

  /**
   * Open PDF in external application/browser
   * Optimized for iOS and Android compatibility
   */
  openPdfExternal(url: string): void {
    if (!url) {
      console.warn('No URL provided for external PDF opening');
      return;
    }

    console.log('Opening PDF externally:', url);

    try {
      // For mobile devices, prefer direct window.open for better compatibility
      if (
        this.platform.is('mobile') ||
        this.platform.is('ios') ||
        this.platform.is('android')
      ) {
        // Direct window.open works best on mobile devices
        window.open(url, '_blank', 'noopener,noreferrer');
      } else {
        // For desktop, try modalServ.openLink first, then fallback to window.open
        try {
          this.modalServ.openLink(url);
        } catch (modalError) {
          console.log('modalServ.openLink failed, using window.open fallback');
          window.open(url, '_blank', 'noopener,noreferrer');
        }
      }
    } catch (error) {
      console.error('Error opening PDF externally:', error);

      // Ultimate fallback - try window.open with different parameters
      try {
        window.open(url, '_system');
      } catch (ultimateError) {
        console.error('All PDF opening methods failed:', ultimateError);
      }
    }
  }

  async reservation(): Promise<void> {
    this.processing = true;
    if (this.dataServ.menuItem.booking_system === 'link to external url') {
      window.open(this.dataServ.menuItem.external_booking_engine_url, '_blank');
    } else {
      if (!this.authServ.isLogged) {
        const isLoggedIn = await this.modalServ.login();

        if (!isLoggedIn) {
          this.processing = false;
          return;
        }
      }

      // this.router.navigate(['restaurant-booking', this.dataServ.menuItem.id], {
      //   queryParams: {
      //     fromRestaurantPage: true,
      //   },
      //   replaceUrl: true,
      // });

      this.navCtrl.navigateForward(
        `restaurant-booking/${this.dataServ.menuItem.id}?fromRestaurantPage=true&sectionId=${this.dataServ.menuSection.id}`
      );
    }
    this.processing = false;
  }

  async resButton(): Promise<void> {
    this.processing = true;
    await this.modalServ.resButton();
    this.processing = false;
  }

  async cart(): Promise<void> {
    this.processing = true;
    await this.modalServ.cart();
    this.processing = false;
  }

  async follow() {
    this.processing = true;

    if (!this.authServ.profile) {
      await this.authServ.getMe();
    }

    try {
      const ISFOLLOW = !Boolean(
        this.followServ.follows.find(
          (x) => x.followed_id === this.dataServ.menuItem.id
        )
      );

      await this.followServ.postFollow(
        this.dataServ.menuItem,
        ISFOLLOW,
        this.authServ.profile.id
      );
    } catch {}

    this.processing = false;
  }

  async sendForm() {
    this.processing = true;

    if (!this.authServ.profile) {
      await this.authServ.getMe();
    }

    const REQ = new RequestHeaderModel(
      this.authServ.profile,
      '',
      'FormFields',
      'FormFields',
      this.dataServ.menuItem,
      this.caption.transform(
        this.dataServ.menuSection.title,
        this.dataServ.rData.hotel_language || 'tr'
      ),
      this.caption.transform(
        this.dataServ.menuCategory.title,
        this.dataServ.rData.hotel_language || 'tr'
      ),
      this.caption.transform(
        this.dataServ.menuItem.name,
        this.dataServ.rData.hotel_language || 'tr'
      ),
      new Date().toISOString(),
      this.dataServ.menuItem.form_fields
    );

    const LINE = new RequestLineModel(
      1,
      REQ,
      'FormFields',
      `${this.authServ.profile.first_name} ${this.authServ.profile.last_name}`,
      'FormField',
      '',
      1,
      0,
      '',
      ''
    );

    REQ.requestlines.push(LINE);

    try {
      await this.reqServ.postrequest([REQ]);
      this.dataServ.menuItem.form_fields.map((field) => {
        field.value = null;
      });
    } catch {}

    this.processing = false;
  }
}
